import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Main from "./Component/Main";
import "./App.css";
import { Membership } from "./Component/Membership";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/membership" element={<Membership />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
